import React, { createContext, useContext, useState } from "react";
import apolloClient from "graphql/client";
import { GetZoomTokenRequest } from "graphql/sessions/sessions.gql";

type User = {
  id: string;
  displayName: string;
  profileImageUrl: string;
  askRecordingConsent: boolean;
  showFirstVideoCallInfo: boolean;
};

export interface StateContextType {
  fetchZoomSignature(
    roomName: string,
    recordingAllowed?: boolean
  ): Promise<{ signature: string; allowRecording: boolean }>;
  user?: null | User;
  isFetching: boolean;
}

export const StateContext = createContext<StateContextType>(null!);

export interface StateContextType {
  fetchZoomSignature(
    roomName: string,
    recordingAllowed?: boolean
  ): Promise<{ signature: string; allowRecording: boolean }>;
  user?: null | User;
  isFetching: boolean;
}

export default function AppStateProvider(
  props: React.PropsWithChildren<{ user: User }>
) {
  const [isFetching, setIsFetching] = useState(false);

  const contextValue = {
    user: props.user,
    isFetching,
    fetchZoomSignature: async (roomName: any, recordingAllowed = false) => {
      setIsFetching(true);
      try {
        const userId = props.user?.id;
        const generatedSessionName = `${
          process.env.REACT_APP_ZOOM_SESSION_NAME
        } - ${roomName.split("-")[0].toUpperCase()}`;
        const response = await apolloClient.query({
          query: GetZoomTokenRequest,
          fetchPolicy: "no-cache",
          variables: {
            id: roomName,
            input: {
              sessionName: generatedSessionName,
              role: 1,
              sessionKey: roomName,
              userId: userId
            }
          }
        });
        const signature = response.data.zoomToken.signature;
        return signature;
      } finally {
        setIsFetching(false);
      }
    }
  } as StateContextType;

  return (
    <StateContext.Provider value={contextValue}>
      {props.children}
    </StateContext.Provider>
  );
}

export function useAppState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error("useAppState must be used within the AppStateProvider");
  }
  return context;
}
